import { Component, OnInit, Input } from '@angular/core';
import { DataService, OptionsserviceService, LoansService, OperationsService } from '../../_services/index';

@Component({
  selector: 'app-customerdetails',
  templateUrl: './customerdetails.component.html',
  styleUrls: ['./customerdetails.component.css','./style.css','./boot-outline-btn.css']
})
export class CustomerdetailsComponent implements OnInit {
  customer:any;
  @Input('currentUser') currentUser:any;
  parentRouteId:any;
  constructor(private dataService: DataService,private loansService: LoansService) { 
    this.dataService.requestLoad.subscribe(res => {
      this.parentRouteId = res.request_id;
      this.getCustomerDetails();
    })
  }

  ngOnInit() {
  }
  getCustomerDetails(){
    this.loansService.getLoanCustomer(this.currentUser.token, this.parentRouteId)
      .subscribe(data => {
        this.customer = data.customer;
      });
  }
}
